export default __webpack_public_path__ + "static/media/IMG_2231.d3426192.JPG";